<template>
  <div id="contenedor-registrar-nuevo-proyecto">
    <v-form
      ref="registrarProyecto">
      <v-row no-gutters>
        <v-col cols="12" class="my-3">
          <CustomTextArea
            v-model="proyecto.descripcion"
            label="Descripción"
            placeholder=""
            rows="2"
            :rules="[mixReglas.requerido]">
          </CustomTextArea>
        </v-col>
        <v-col cols="12">
          <div style="border: 1px solid #eee;" class="rounded-lg">
            <v-toolbar dense flat class="mx-1">
              Seleccionar responsables
              <v-chip class="ml-1" small color="primary">
                {{ responsablesSeleccionados.length }}
              </v-chip>
            </v-toolbar>
            <v-divider></v-divider>
            <div style="height: 250px;" class="overflow-y-auto">
              <SeleccionarResponsables
                v-model="responsablesSeleccionados">
              </SeleccionarResponsables>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';
import AGREGAR_PROYECTO from '@/graphql/mutations/administracion/control-proyectos/agregarProyecto.gql';
import CustomTextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import SeleccionarResponsables from '@/components/administracion/control-proyectos/responsables/Seleccionar.vue';

export default {
  name: 'RegistrarNuevoProyecto',
  components: {
    CustomTextArea,
    SeleccionarResponsables,
  },
  props: {
    idObra: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      responsablesSeleccionados: [],
      proyecto: {
        idObra: this.idObra,
        descripcion: null,
        responsables: [],
        documentos: [],
      },
    };
  },
  methods: {
    async guardar() {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PROYECTO,
          variables: {
            proyecto: this.proyecto,
          },
          update: (store, { data: { agregarProyecto } }) => {
            const data = store.readQuery({ query: OBRAS });
            const { obras } = data;
            const obraRegistrada = obras.find(({ id }) => id === this.idObra);

            if (obraRegistrada) {
              obraRegistrada.proyecto = agregarProyecto;
              const index = obras
                .findIndex((obra) => obra.id === this.idObra);
              if (index !== -1) {
                obras.splice(index, 1, obraRegistrada);
              }
              store.writeQuery({ query: OBRAS, data });
            }
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
    },
    cancelar() {
      this.proyecto.idObra = null;
      this.proyecto.descripcion = null;
      this.proyecto.responsables = [];
      this.proyecto.documentos = [];
      this.responsablesSeleccionados = [];
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  watch: {
    responsablesSeleccionados: {
      handler(responsables) {
        this.proyecto.responsables = responsables.map(({ id }) => ({
          idFuncionario: id,
          esLider: false,
        }));
      },
    },
  },
};
</script>

<style lang="scss">

</style>
